export default __webpack_public_path__ + "static/media/13.11a66b6c.jpg";